import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { HERO_POOL } from "@/data/villas";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";

export default function Events() {
  const { t } = useLang();
  return (
    <>
      <SEO pageKey="events" />
      <section className="relative -mt-20 h-[70svh] overflow-hidden">
        <img src={HERO_POOL} alt="Événements privés" className="absolute inset-0 h-full w-full object-cover kenburns" />
        <div className="absolute inset-0 bg-black/45" />
        <div className="relative z-10 h-full dh-container flex flex-col justify-end pb-16 text-white">
          <div className="dh-overline text-[color:hsl(var(--dh-ocre))]">{t.events.overline}</div>
          <h1 className="font-serif text-5xl md:text-7xl mt-4 max-w-3xl">{t.events.title}</h1>
        </div>
      </section>

      <section className="dh-container py-24 grid md:grid-cols-2 gap-16 items-start">
        <div>
          <p className="text-lg text-[color:hsl(var(--dh-muted))] leading-relaxed">{t.events.subtitle}</p>
          <Link to="/contact" data-testid="events-cta" className="mt-8 inline-flex dh-btn-primary">
            {t.events.contactUs} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <ul className="space-y-4">
          {t.events.types.map((type, i) => (
            <li key={i} data-testid={`event-type-${i}`} className="flex items-baseline gap-4 border-b border-[color:hsl(var(--dh-ocre)/0.2)] pb-4">
              <span className="dh-overline text-[color:hsl(var(--dh-terracotta))]">0{i + 1}</span>
              <span className="font-serif text-2xl">{type}</span>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
